import { PrimaryButton } from '@systemeio/ui'
import { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { WebhookInterface } from '../types/webhook-settings-interface'
import WebhookModal from './webhook-modal'

interface WebhookCreateModalProps {
  onSave?: (webhook: WebhookInterface) => void
}

const WebhookCreateModal = ({ onSave }: WebhookCreateModalProps) => {
  const { t } = useLocoTranslation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <PrimaryButton onClick={() => setIsOpen(true)}>{t('global.create')}</PrimaryButton>
      <WebhookModal isOpen={isOpen} onClose={() => setIsOpen(false)} onSave={onSave} />
    </>
  )
}

export default WebhookCreateModal
